import create from "zustand";
import { ReportType } from "../models/Reports";
import { Team, getTeamsForEnvironment } from "../models/Team";
import { ExplorerEnvironment } from "./Cache";

interface ReportState {
  team: Team | null;
  teamsByEnvironment: Partial<Record<ExplorerEnvironment, Team[]>>;
  initTeams: (environment?: ExplorerEnvironment) => Promise<void>;
  setTeam: (t: Team | null) => void;
  setReportType: (r: ReportType | null) => void;
  reportType: ReportType | null;
}

export const useReportStore = create<ReportState>((set, get) => ({
  team: null,
  teamsByEnvironment: {
    [ExplorerEnvironment.NBA]: getTeamsForEnvironment(ExplorerEnvironment.NBA),
    [ExplorerEnvironment.DRAFT]:
      getTeamsForEnvironment(ExplorerEnvironment.DRAFT),
  },
  initTeams: async (
    environment: ExplorerEnvironment = ExplorerEnvironment.NBA
  ) => {
    const teams = getTeamsForEnvironment(environment);
    set((state) => ({
      teamsByEnvironment: {
        ...state.teamsByEnvironment,
        [environment]: teams,
      },
    }));
  },
  setTeam: (team: Team | null) => set((state) => ({ team })),
  reportType: null,
  setReportType: (reportType: ReportType | null) =>
    set((state) => ({ reportType })),
}));
